import { Button, Card } from 'react-daisyui'

const Unauthorized = () => {
    return (
        <Card side="lg">
          <Card.Image
            src="/lf-update-150x150.jpg"
            alt="Life-Fit Logo"
          />
          <Card.Body>
            <Card.Title tag="h2">Access Denied</Card.Title>
            <p>You do not have permission to access this page. Contact XXXXXXXXXXXXXXXXXX to become a contributor.</p>
            <Card.Actions className="justify-end">
              <Button color="primary">Logout</Button>
            </Card.Actions>
          </Card.Body>
        </Card>
      );
};

export default Unauthorized;